// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase : {
    apiKey: "AIzaSyDTSILsY7tltBuG9l3vDTjumSvtgacZ_qI",
    authDomain: "echooo-cloud.firebaseapp.com",
    databaseURL: "https://echooo-cloud.firebaseio.com",
    projectId: "echooo-cloud",
    storageBucket: "echooo-cloud.appspot.com",
    messagingSenderId: "1034966064412",
    appId: "1:1034966064412:web:ed5205acfb27da9a9feed9"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
